import { Component, inject, OnInit, signal, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { Router } from '@angular/router';
import { getResourceById, Resources } from '@app/resources';
import { PageTitleComponent } from '@shared/components/page-title/page-title.component';
import { TableLazyLoadEvent } from '@primeng/table';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ButtonModule } from '@primeng/button';
import { TranslatePipe } from '@ngx-translate/core';
import {
  PropertiesTableComponent
} from '@modules/universal-billing/properties/properties-table/properties-table.component';
import { Property } from '@modules/settings/properties/properties.interface';
import { PropertiesService } from '@modules/settings/properties/properties.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs';
import {NgCanDirective} from '@common/rbac/ng-can.directive';

@Component({
  selector: 'app-properties',
  standalone: true,
  imports: [
    PageTitleComponent,
    NgClass,
    ButtonModule,
    NgForOf,
    TranslatePipe,
    PropertiesTableComponent,
    ReactiveFormsModule,
    NgCanDirective,
    NgIf
  ],
  templateUrl: './properties.component.html',
  styleUrl: './properties.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PropertiesComponent extends BasicTableComponent<Property> implements OnInit {
  public breadCrumbItems = [];
  public service = inject(PropertiesService);
  public expandedRows: { [key: string]: boolean } = {};
  activeTab: WritableSignal<any> = signal('card');
  searchControl = new FormControl('');
  @ViewChild('table') table: PropertiesTableComponent;
  tabs = [
    {
      key: 'card',
      icon: 'ri-grid-fill',
      label: 'APARTMENT.CARDS'
    },
    {
      key: 'table',
      icon: 'ri-table-alt-fill',
      label: 'APARTMENT.LIST'
    }
  ];
  protected router = inject(Router);

  ngOnInit() {
    super.ngOnInit();
    this.breadCrumbItems = [
      {label: 'MENU.UNIVERSAL_BILLING'},
      {label: this.service.title, link: Resources.Properties},
    ];
    this.searchControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe(term => {
        this.table.triggerGlobalSearch(term);
      });

  }

  setActiveTab(tab: string): void {
    this.activeTab.set(tab);
  }

  onView(data: any) {
    this.router.navigate([getResourceById(Resources.PropertiesProfile, data.id)]);
  }

  loadData(event: TableLazyLoadEvent | null = null) {
    if (this.table) {
      this.table.loadData();
    }
  }
}
